import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class VersionCheckerService {
	public hasVersionMismatch$ = new Subject<boolean>();

	constructor() {}

	handleVersionMismatch(versionMismatch: string | null) {
		if (versionMismatch !== null) {
			this.hasVersionMismatch$.next(true);
		}
	}
}
